// state
export const state = {
  type: localStorage.getItem('gameType') || 'classic',
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  setGameType(state, { type }) {
    state.type = type
    localStorage.setItem('gameType', type)
  },
}
// actions
export const actions = {
  setGameType({ commit }, { type }) {
    commit('setGameType', { type })
  },
}
